import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import AssetServices from "../../../services/AssetServices";
import Pagination from "../Pagenation/Pagenation";

const AssetList = () => {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState(50); // rows per page
  const [activePage, setActivePage] = useState(0);
  const [test, setTest] = useState(0);
  const [storeSortOrder, setStoreSortOrder] = useState(null);

  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];



  // Load stores and role
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    const availableStores = user?.data?.user?.store || [];
    const role = user?.data?.user?.role || "user";
    setStores(availableStores);
    setUserRole(role);
    if (role !== "superAdmin" && availableStores.length > 0) {
      setSelectedStore(availableStores[0]);
    }
  }, []);

  // Fetch assets
  useEffect(() => {
    const fetchAssets = async () => {
      try {
        setLoading(true);
        let response;
        if (userRole === "superAdmin") {
          response = await AssetServices.getAssetsByStore();
        } else if (selectedStore?._id) {
          response = await AssetServices.getAssetsByStore(selectedStore._id);
        } else {
          setData([]);
          setFilteredData([]);
          setLoading(false);
          return;
        }

        const assets = response?.data?.assets || [];
        setData(assets);
        setFilteredData(assets);
      } catch (err) {
        console.error("Error fetching assets:", err);
        setError("There is some problem in fetching data!");
      } finally {
        setLoading(false);
      }
    };

    fetchAssets();
  }, [selectedStore, userRole, test]);

  // Search
  useEffect(() => {
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      const filtered = data.filter((item) => {
        const partNo = String(item?.masterItem?.partNo || "").toLowerCase();
        const description = String(item?.masterItem?.description || "").toLowerCase();
        const serial = String(item?.serialNumber || "").toLowerCase();
        const vendor = String(item?.vendor || "").toLowerCase();
        const store = String(item?.store?.name || "").toLowerCase();
        const equipmentNo = String(item?.equipmentNo || "").toLowerCase();
        return (
          partNo.includes(search) ||
          description.includes(search) ||
          serial.includes(search) ||
          vendor.includes(search) ||
          equipmentNo.includes(search) ||
          store.includes(search)
        );
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchTerm, data]);

  useEffect(() => {
    setActivePage(0);
  }, [filteredData, selectedStore]);

  // Pagination
  const totalPages = Math.ceil(filteredData.length / sort);

  const handlePageChange = (page) => {
    setActivePage(page);
  };

  const handleSelectChange = (selectedOption) => {
    setSort(selectedOption.value);
    setActivePage(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB");
  };

  const handleStoreSort = () => {
    const newOrder = storeSortOrder === "asc" ? "desc" : "asc";
    setStoreSortOrder(newOrder);
    const sorted = [...filteredData].sort((a, b) => {
      const storeA = (a?.store?.name || "").toLowerCase();
      const storeB = (b?.store?.name || "").toLowerCase();
      return newOrder === "asc"
        ? storeA.localeCompare(storeB)
        : storeB.localeCompare(storeA);
    });
    setFilteredData(sorted);
  };

  return (
    <>
      <div className="row">
        {loading ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ height: "300px", width: "100%" }}
          >
            <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }}></div>
            <p className="mt-3 text-primary fw-semibold">Assets Loading...</p>
          </div>
        ) : (
          <div className="col-xl-12">
            {/* Filter Section */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      {userRole !== "superAdmin" && (
                        <div className="col-xl-3 col-xxl-4 mb-3">
                          <label className="fw-semibold mb-1">Select Store</label>
                          <select
                            className="form-select"
                            style={{ height: "55px" }}
                            value={selectedStore?._id || ""}
                            onChange={(e) => {
                              const store = stores.find((s) => s._id === e.target.value);
                              setSelectedStore(store);
                            }}
                          >
                            {stores.length === 0 ? (
                              <option value="">No stores available</option>
                            ) : (
                              stores.map((store) => (
                                <option key={store._id} value={store._id}>
                                  {store.name}
                                </option>
                              ))
                            )}
                          </select>
                        </div>
                      )}

                      <div className="col-xl-3 col-xxl-4">
                        <label className="fw-semibold mb-1">Search</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Part No, Description, Equipment No, Serial, Vendor or Store"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>

                      <div className="col-xl-3 col-xxl-4">
                        <label className="fw-semibold mb-1">Rows per page</label>
                        <Select
                          placeholder="Select rows"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Asset List Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>Asset List
                  <span className="badge bg-orange ms-2">{filteredData.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to="#"
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div
                          className="scrolltable"
                        >
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead
                              className="sticky-table-header"
                            >
                              <tr>
                                <th>S.No</th>
                                <th>Part No</th>
                                <th>Description</th>
                                <th>Equipment No</th>
                                <th>Category</th>
                                <th
                                  style={{ cursor: "pointer" }}
                                  onClick={handleStoreSort}
                                >
                                  Store{" "}
                                  {storeSortOrder === "asc" ? (
                                    <i className="fas fa-arrow-up ms-1 text-primary"></i>
                                  ) : storeSortOrder === "desc" ? (
                                    <i className="fas fa-arrow-down ms-1 text-primary"></i>
                                  ) : (
                                    <i className="fas fa-sort ms-1 text-muted"></i>
                                  )}
                                </th>
                                <th>Vendor</th>
                                <th>Serial Number</th>
                                <th>Model</th>
                                {/* ✅ Show Purchased Amount column only for SuperAdmin */}
                                {userRole === "superAdmin" && <th>Purchased Amount</th>}
                                <th>Condition</th>
                                <th>Status</th>
                                <th>Created At</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredData.length > 0 ? (
                                filteredData
                                  .slice(
                                    activePage * sort,
                                    (activePage + 1) * sort
                                  )
                                  .map((item, index) => (
                                    <tr key={item._id}>
                                      <td>{activePage * sort + index + 1}</td>
                                      <td>{item?.masterItem?.partNo || "-"}</td>
                                      <td className="scrollable-description">{item?.masterItem?.description || "-"}</td>
                                      <td>{item?.equipmentNo || "-"}</td>
                                      <td>{item?.masterItem?.category?.name || "-"}</td>
                                      <td className="scrollable-description">{item?.store?.name || "-"}</td>
                                      <td className="scrollable-description">{item?.vendor || "-"}</td>
                                      <td>{item?.serialNumber || "-"}</td>
                                      <td>{item?.model || "-"}</td>
                                      {/* ✅ Show Purchased Amount value only for SuperAdmin */}
                                      {userRole === "superAdmin" && (
                                        <td>
                                          {item?.purchasedAmount
                                            ? Number(item.purchasedAmount).toLocaleString("en-IN", {
                                              style: "currency",
                                              currency: "INR",
                                              minimumFractionDigits: 2,
                                            })
                                            : "-"}

                                        </td>
                                      )}
                                      <td>{item?.condition || "-"}</td>
                                      <td>{item?.status || "-"}</td>
                                      <td>{formatDate(item?.createdAt)}</td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td colSpan="11" className="text-center">
                                    {userRole !== "superAdmin" && !selectedStore
                                      ? "Please select a store to view assets."
                                      : "No records found."}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination footer same as MasterList */}
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">

                          <div className="dataTables_info">
                            Showing{" "}
                            {filteredData.length > 0
                              ? activePage * sort + 1
                              : 0}{" "}
                            to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePage + 1) * sort
                            )}{" "}
                            of {filteredData.length} entries
                          </div>

                          {totalPages > 0 && (
                            <Pagination
                              activePage={activePage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssetList;
